import jQuery from 'jquery';
import MetisMenu from 'metismenujs';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import MenuItem from './menuItem';
import MenuTree from './menuTree';
import navHeaderMini from '../../assets/images/navigation/nav-header-mini.png';
import { correctHeight } from '../helpers';

class MM extends React.Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }

  componentWillUnmount() {
    if (this.mm && typeof this.mm.dispose === 'function') {
      this.mm.dispose();
    }
  }

  render() {
    return (
      <div className="mm-wrapper">
        <ul className="nav metismenu" ref={el => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const Navigation = ({ location: { pathname }, rota, pessoaLogada, dadosEmpresa }) => {
  useEffect(() => {
    jQuery('.metismenu a').click(() => {
      setTimeout(() => {
        correctHeight();
      }, 300);
    });

    if (jQuery('body').hasClass('fixed-sidebar')) {
      jQuery('.sidebar-collapse').slimscroll({
        height: '100%',
      });
    }
  });

  const renderMenuItemTree = menu => (
    <MenuItem
      key={menu.funcaoId}
      location={pathname}
      path={`#${menu.rota}`}
      icon={menu.icone}
      label={menu.funcaoDescricao}
      tree
    />
  );

  const renderMenuItem = menu => (
    <MenuItem
      key={menu.funcaoId}
      location={pathname}
      path={`#${menu.rota}`}
      icon={menu.icone}
      label={menu.funcaoDescricao}
    />
  );

  const renderMenuTree = menu => (
    <MenuTree key={menu.funcaoId} icon={menu.icone} label={menu.funcaoDescricao}>
      {menu.menus.map(item => {
        if (item.menus && item.menus.length > 0) {
          return renderMenuTree(item);
        }
        return renderMenuItemTree(item);
      })}
    </MenuTree>
  );

  return (
    <nav className="navbar-default navbar-static-side" role="navigation">
      <div className="sidebar-collapse">
        <MM>
          <li className="nav-header">
            <div className="dropdown profile-element" style={{ textAlign: 'center' }}>
              <img
                alt="profile"
                className="rounded-circle"
                style={{ width: 80, height: 80 }}
                src={navHeaderMini}
              />
              <span className="block m-t-xs font-bold">
                <strong className="text-navy text-sm">{pessoaLogada.nome}</strong>
              </span>
              <span className="text-muted text-xs block">{pessoaLogada.tipo}</span>
            </div>
            <div className="logo-element">
              <img alt="mini-logo" className="img-sm" src={navHeaderMini} />
            </div>
          </li>

          {rota &&
            rota.menus &&
            rota.menus.length > 0 &&
            rota.menus.map(menu => {
              if (menu.permitido) {
                if (menu.menus && menu.menus.length > 0) {
                  return renderMenuTree(menu);
                }
                return renderMenuItem(menu);
              }

              return undefined;
            })}
          {dadosEmpresa.configuracaoBloqueioCfop && dadosEmpresa.configuracaoBloqueioCfop.ativo && (
            <MenuItem
              key="documentos-bloqueados-cfop"
              location={pathname}
              path="#/documentos-bloqueados"
              icon="ban"
              label="Documentos bloqueados"
            />
          )}
        </MM>
      </div>
    </nav>
  );
};

const mapStateToProps = state => ({
  rota: state.rota,
  pessoaLogada: state.usuario.pessoaLogada,
  dadosEmpresa: state.empresa.dadosEmpresa,
});

export default withRouter(connect(mapStateToProps)(Navigation));
